var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewRestSignupRequest extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.ehfInvoice = false;
        /** @override */ this.email = '';
        /** @override */ this.firstName = '';
        /** @override */ this.invoiceAddress = '';
        /** @override */ this.invoicePostalAddress = '';
        /** @override */ this.invoicePostalCode = '';
        /** @override */ this.lastName = '';
        /** @override */ this.orgName = '';
        /** @override */ this.orgNo = '';
        /** @override */ this.phone = '';
        /** @override */ this.postalAddress = '';
        /** @override */ this.postalNo = '';
        /** @override */ this.streetAddress = '';
    }
}
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewRestSignupRequest.prototype, "ehfInvoice", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "email", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "firstName", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "invoiceAddress", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "invoiceEmail", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "invoicePostalAddress", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "invoicePostalCode", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "lastName", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "orgName", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "orgNo", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "password", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "phone", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "postalAddress", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "postalNo", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "streetAddress", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewRestSignupRequest.prototype, "username", void 0);
